// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"74":"About","177":"home","372":"Business","596":"404","952":"Address","997":"Message"}[chunkId] || chunkId) + "." + {"74":"41ec6b05","177":"395f35b1","372":"a3596613","596":"1501a7a8","604":"7a6e8682","952":"56deecb3","997":"9631eee4"}[chunkId] + ".js";
};